import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { track } from "@/lib/api";
import { useConfig } from "@/hooks/useConfig";

export const BookButton = ({
  label = "Book a First Walk — £60",
  className = "",
  testid = "book-first-walk-cta",
  dark = false,
}) => (
  <Link
    to="/book"
    data-testid={testid}
    onClick={() => track("cta_book_click", { label })}
    className={`inline-flex items-center justify-center rounded-full px-8 py-4 text-sm md:text-base font-semibold tracking-wide transition-colors duration-300 ${
      dark
        ? "bg-paper text-ink hover:bg-paper2"
        : "bg-ink text-paper hover:bg-pine"
    } ${className}`}
  >
    {label}
  </Link>
);

export const DisclaimerNote = ({ dark = false, className = "", testid = "booking-disclaimer" }) => (
  <p
    data-testid={testid}
    className={`max-w-xl text-xs md:text-sm leading-relaxed ${
      dark ? "text-paper/45" : "text-ink/45"
    } ${className}`}
  >
    By booking, you confirm that you understand Walk It Through does not
    provide legal, financial, medical, therapeutic or emergency advice or
    services.
  </p>
);

export const WhatsAppButton = ({ className = "", testid = "whatsapp-cta", dark = false }) => {
  const { data: config } = useConfig();
  if (!config?.whatsapp_number) return null;
  const text = encodeURIComponent(
    "Hi Luke, I've come across Walk It Through and would like to find out more about booking a First Walk."
  );
  return (
    <a
      href={`https://wa.me/${config.whatsapp_number}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => track("cta_whatsapp_click")}
      className={`inline-flex items-center justify-center gap-2 rounded-full border px-8 py-4 text-sm md:text-base font-semibold tracking-wide transition-colors duration-300 ${
        dark
          ? "border-paper/30 text-paper hover:bg-paper/10"
          : "border-ink/25 text-ink hover:bg-ink/5"
      } ${className}`}
    >
      <MessageCircle className="h-4 w-4" aria-hidden="true" />
      Message Luke on WhatsApp
    </a>
  );
};
